const locale = {
    placeholder: 'Wybierz godzinę',
    rangePlaceholder: ['Czas rozpoczęcia', 'Czas zakończenia'],
};
export default locale;
